<ng-container *ngIf="vraag.vraagtype === vraagtype.LabelBreak" [ngTemplateOutlet]="labelBreak"
  [ngTemplateOutletContext]="{vraag:vraag}"></ng-container>

<div *ngIf="vraag.vraagtype !== vraagtype.LabelBreak" [ngClass]="stylingClass(vraag, false)" data-hj-suppress>
  <app-icon *ngIf="isSchadedetail && vraag.stappenplan_stappen" [icon]="vraag.stappenplan_stappen"
    [iconCssClass]="'ols-vraag-icon'"></app-icon>
  <div *ngIf="vraag.vraagregels && vraag.vraagregels.length > 0" class="ols-vraag-regels">
    <span *ngFor="let regel of vraag.vraagregels" innerHTML="{{geefRegelVraag(vraag, regel, true)}}"></span>
  </div>
  <ul *ngIf="vraag.vraag_bullets && vraag.vraag_bullets.length > 0" class="ols-vraag-bullets">
    <li *ngFor="let bullet of vraag.vraag_bullets">{{bullet}}</li>
  </ul>
  <ng-container *ngIf="vraag.vraagtype === vraagtype.LabelBmGevolgen">
    <ul class="ols-ml">
      <li *ngFor="let t of tekstenBmGevolgen" [innerHTML]="t"></li>
    </ul>
    <div *ngIf="bmgevolgenDisclaimerTonen" class="ols-italic">
      <app-sharedtekst [key]="'bmgevolgen_disclaimer'"></app-sharedtekst>
    </div>
  </ng-container>
  <div *ngIf="vraag.antwoorden && vraag.antwoorden.length > 0" class="ols-vraag-antwoorden-container">
    <div *ngFor="let antwoord of vraag.antwoorden" class="ols-vraag-antwoord">
      <app-icon [icon]="antwoord.icon" [iconCssClass]="'ols-vraag-antwoord-icon'"></app-icon>
      <div class="ols-vraag-antwoord-text">
        <div *ngIf="antwoord.titel" class="ols-vraag-antwoord-title">{{antwoord.titel}}</div>
        <div *ngIf="antwoord.antwoordregels && antwoord.antwoordregels.length > 0" class="ols-vraag-antwoord-regels">
          <span *ngFor="let regel of antwoord.antwoordregels">{{regel}}</span>
        </div>
        <ul *ngIf="antwoord.antwoord_bullets && antwoord.antwoord_bullets.length > 0"
          class="ols-vraag-antwoord-bullets">
          <li *ngFor="let bullet of antwoord.antwoord_bullets">{{bullet}}</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="vraag.connectedVragen && vraag.connectedVragen.length > 0">
  <div *ngFor="let connectedVraag of vraag.connectedVragen" [ngClass]="stylingClass(connectedVraag, true)"
    class="ols-connectedvraag-container" data-hj-suppress>

    <ng-container *ngIf="connectedVraag.vraagtype === vraagtype.LabelBreak" [ngTemplateOutlet]="labelBreak"
      [ngTemplateOutletContext]="{vraag:connectedVraag}"></ng-container>

    <ng-container *ngIf="connectedVraag.vraagtype !== vraagtype.LabelBreak">
      <div *ngIf="connectedVraag.stappenplan_stappen" class="ols-icon-titel"
        [ngClass]="connectedVraag.stappenplan_stappen"></div>
      <div class="ols-connectedvraag-text">
        <div *ngIf="connectedVraag.titel" class="ols-connectedvraag-title"
          innerHTML="{{geefRegelVraag(connectedVraag, connectedVraag.titel, true)}}"></div>

        <div *ngIf="connectedVraag.vraagtype === vraagtype.LabelProgress" class="ols-progress"></div>

        <div class="ols-connectedvraag-regels">
          <ng-container [ngSwitch]="connectedVraag.vraagtype">
            <ng-container *ngSwitchDefault>
              <ng-container *ngIf="connectedVraag.vraagregels && connectedVraag.vraagregels.length > 0">
                <span *ngFor="let regel of connectedVraag.vraagregels"
                  innerHTML="{{geefRegelVraag(connectedVraag, regel, true)}}"></span>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="vraagtype.LabelVisite">
              <div *ngIf="connectedVraag.vraagregels && connectedVraag.vraagregels.length > 0" class="ols-card">
                <div class="ols-card-image-text">
                  <div class="ols-telefoonman"></div>
                  <div>
                    <div *ngFor="let regel of connectedVraag.vraagregels; let i = index"
                      [ngClass]="{'ols-bold': i === 0}">
                      {{regel}}</div>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="vraagtype.LabelBmGrijs">
              <ul class="ols-ml">
                <li *ngFor="let t of tekstenBmBelangrijk" [innerHTML]="t"></li>
              </ul>
            </ng-container>

            <ng-container *ngSwitchCase="vraagtype.LabelBmGevolgen">
              <ul class="ols-ml">
                <li *ngFor="let t of tekstenBmGevolgen" [innerHTML]="t"></li>
              </ul>

              <div *ngIf="bmgevolgenDisclaimerTonen" class="ols-italic">
                <app-sharedtekst [key]="'bmgevolgen_disclaimer'"></app-sharedtekst>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <ul *ngIf="connectedVraag.vraag_bullets && connectedVraag.vraag_bullets.length > 0" class="ols-vraag-bullets">
          <li *ngFor="let bullet of connectedVraag.vraag_bullets"
            innerHTML="{{geefRegelVraag(connectedVraag, bullet, true)}}"></li>
        </ul>
      </div>

      <div *ngIf="connectedVraag.antwoorden && connectedVraag.antwoorden.length > 0"
        class="ols-connectedvraag-antwoorden-container">
        <div *ngFor="let antwoord of connectedVraag.antwoorden; let i = index" class="ols-antw"
          [ngClass]="'antwoord' + i">
          <div *ngIf="antwoord.groep_titel" class="ols-label-antwoord-groep">{{antwoord.groep_titel}}</div>
          <div class="ols-connectedvraag-antwoord" [ngClass]="{'ols-totaalbedrag' : isTotaalbedrag(antwoord)}">
            <app-icon [icon]="antwoord.icon" [iconCssClass]="'ols-connectedvraag-antwoord-icon'"></app-icon>
            <div *ngIf="connectedVraag.vraagtype !== vraagtype.Label10" class="ols-connectedvraag-antwoord-text">
              <div *ngIf="connectedVraag.vraagtype === vraagtype.LabelOpsomming" class="ols-opsomming"
                [innerHTML]="geefIndexPlus(i)"></div>
              <div *ngIf="antwoord.titel" class="ols-connectedvraag-antwoord-title"
                [innerHTML]="geefRegelAntwoord(antwoord, antwoord.titel, true)"></div>
              <div *ngIf="antwoord.antwoordregels && antwoord.antwoordregels.length > 0"
                class="ols-connectedvraag-antwoord-regels">
                <ng-container *ngFor="let regel of antwoord.antwoordregels">
                  <div class="ols-bedrag-groep">
                    <div class="ols-min">{{minTeken(antwoord, regel)}}</div>
                    <div class="ols-euro" [innerHTML]="geefEuro(antwoord, regel)"></div>
                    <div class="ols-bedrag">{{geefRegelAntwoord(antwoord, regel, false)}}</div>
                  </div>
                </ng-container>
              </div>
              <ul *ngIf="antwoord.antwoord_bullets && antwoord.antwoord_bullets.length > 0"
                class="ols-connectedvraag-antwoord-bullets">
                <li *ngFor="let bullet of antwoord.antwoord_bullets">{{bullet}}</li>
              </ul>
            </div>
          </div>
          <div *ngIf="connectedVraag.vraagtype === vraagtype.Label10">
            <div class="buttons-container">
              <a href="{{geefUrl(antwoord.antwoordregels)}}" class="button has-ripple"
                id="geefMeetidButton(antwoord.titel)">{{antwoord.titel}}</a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #labelBreak let-vraag="vraag">
  <div class="ols-break" [ngClass]="getVraagClass(vraag)">
    <div class="ols-break-sluit"></div>
    <div class="ols-break-open"></div>
  </div>
</ng-template>